import { render } from "./CustomerApproval.vue?vue&type=template&id=5227644b&scoped=true"
import script from "./CustomerApproval.vue?vue&type=script&lang=js"
export * from "./CustomerApproval.vue?vue&type=script&lang=js"

import "./CustomerApproval.vue?vue&type=style&index=0&id=5227644b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5227644b"]])

export default __exports__